export const styles = {
	gameIdBox: {
		display: 'flex',
	},
	termsAgreedCheckbox: {
		accentColor: '#45657B',
	},
	termsAgreedLabel: {
		marginLeft: '1rem',
	},
}
